export const TRACKING_LOCATIONS = {
  EXPERT_ADVICE: 'EXPERT_ADVICE',
  HOMEPAGE: 'HOMEPAGE',
};

// ts-prune-ignore-next
export const TRACKING_SECTIONS_EA = {
  CHECKLIST_ARTICLE: 'CHECKLIST_ARTICLE',
  EA_ARTICLE: 'EA_ARTICLE',
  EA_SUBTOPIC_PAGE: 'EA_SUBTOPIC_PAGE',
  EA_TOPIC_PAGE: 'EA_TOPIC_PAGE',
};
